module.exports = __webpack_public_path__ + "static/turbine-4216fd9fd0a5ff33529d75f7922d2666.png";